import { up, down } from 'modules/_shared/styles/breakpoints';
import styled from 'styled-components/macro';

const CourseWrapper = styled.div`
  ${down('tablet')} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    & > * {
      &:nth-child(n + 4) {
        margin-top: 40px;
      }
    }
  }

  ${up('tablet')} {
    display: grid;

    & > * {
      &:nth-child(n + 4) {
        display: grid;
        grid-column: 1 / span 2;
      }
    }
  }
`;

export default { CourseWrapper };
